import { Component, OnInit } from '@angular/core';
import {
  MatDialogRef,
} from "@angular/material/dialog";

@Component({
  selector: 'app-access-methods-guide',
  templateUrl: './access-methods-guide.component.html',
  styleUrls: ['./access-methods-guide.component.css']
})
export class AccessMethodsGuideComponent implements OnInit {

  constructor(
    public dialogRef: MatDialogRef<AccessMethodsGuideComponent>,
  ) { }

  ngOnInit(): void {
  }

  closeDialog() {
    this.dialogRef.close();
  }

}
